export default "__VITE_ASSET__543d6064__"